import classNames from 'classnames';
import { IconButton } from '../IconButton';
import { IconClose } from '../QuirkIcons';
import styles from './Crumbs.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import formStyles from './FormFields.module.css';
interface CrumbsProps {
	onDelete?: (remainingItems: string[]) => void;
	items: string[];
	label: string;
	lookup: { [key: string]: string };
}

export const Crumbs: React.FC<CrumbsProps> = ({ onDelete, items, label, lookup }) => {
	const itemDelete = (crumb: string) => {
		const arrayWithItemRemoved: string[] = items.filter(value => value !== crumb);
		onDelete && onDelete(arrayWithItemRemoved);
	};
	const getKeyByValue = (value: string) => {
		return Object.keys(lookup).find(key => lookup[key] === value);
	};
	return (
		<div className={formStyles.fixedField}>
			<div className={formStyles.labelTitle}>{label}</div>
			<div className={styles.crumbsContainer}>
				{items.map((crumb, i) => {
					return (
						<span
							key={crumb + i}
							className={classNames(crumb === 'user' ? styles.disabled : styles.crumbContainer)}
						>
							{crumb !== 'user' && (
								<IconButton
									className={styles.x}
									icon={<IconClose size="small" />}
									onClick={() => itemDelete(crumb)}
								/>
							)}
							<div>{getKeyByValue(crumb)}</div>
						</span>
					);
				})}
			</div>
		</div>
	);
};
